// extracted by mini-css-extract-plugin
export default {"container":"UiToast_container_hLtYI","title":"UiToast_title_kDCbm","content":"UiToast_content_R6obG"};